import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import {
  deleteTaskAssignment,
  updateTaskAssignment,
  handleUpdateHours,
} from "../../store/actions/projects/projectTaskAssignmentActions";

class TaskAssignments extends Component {
  renderTaskAssignments = () => {
    const taskAssignees = this.props.projects.taskAssignees.data;
    let taskAssigneesList = "";

    if (taskAssignees) {
      taskAssigneesList = taskAssignees.length
        ? taskAssignees.map((taskAssignee, key) => {
            return (
              <tr key={key}>
                <td className="text-center" colSpan={3}>
                  {taskAssignee.user.first_name} {taskAssignee.user.last_name}
                </td>
                <td
                  colSpan={2}
                  className="align-right"
                  style={{ border: "1px solid #000" }}
                >
                  <Form.Control
                    type="number"
                    id="t3-charge-hours"
                    value={taskAssignee.hours}
                    className="align-right"
                    onChange={(e) => {
                      this.props.handleUpdateHours(e, taskAssignee.id);
                    }}
                    onBlur={(e) => {
                      const hours = e.target.value;
                      this.props.updateTaskAssignment(
                        taskAssignee.id,
                        taskAssignee.user.id,
                        hours
                      );
                    }}
                  />
                </td>
                <td className="text-center" colSpan={2}>
                  {taskAssignee.targetActivity}
                </td>
                <td className="text-center" colSpan={2}>
                  {taskAssignee.startDate}
                </td>
                <td className="text-center" colSpan={2}>
                  {taskAssignee.endDate}
                </td>
                <td colSpan={1} className="align-center">
                  <Button
                    variant="default"
                    size="sm"
                    onClick={() => {
                      this.props.deleteTaskAssignment(taskAssignee.id);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </td>
              </tr>
            );
          })
        : (taskAssigneesList = (
            <tr>
              <td colSpan={3}>Loading...</td>
            </tr>
          ));
    } else {
      taskAssigneesList = (
        <tr>
          <td colSpan={3}>No task assignments found.</td>
        </tr>
      );
    }
    return taskAssigneesList;
  };

  render() {
    return (
      <>
        <Table>
          <thead className="align-center">
            <tr>
              <th colSpan={3}>Member</th>
              <th colSpan={2}>SLA (mins)</th>
              <th colSpan={2}>Target Activity per Day</th>
              <th colSpan={2}>Start Date</th>
              <th colSpan={2}>End Date</th>
              <th colSpan={1}></th>
            </tr>
          </thead>
          <tbody>{this.renderTaskAssignments()}</tbody>
        </Table>
        <div className="d-flex flex-column">
          <span>
            Total SLA: <b>{this.props.projects.taskAssignees.totalSLA}</b>
          </span>
          <span>
            Total Target Activity Per Day: <b>{this.props.projects.taskAssignees.totalTarget}</b>
          </span>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
});

const mapDispatchToProps = (dispatch) => {
  return {
    deleteTaskAssignment: (...args) => dispatch(deleteTaskAssignment(...args)),
    updateTaskAssignment: (...args) => dispatch(updateTaskAssignment(...args)),
    handleUpdateHours: (...args) => dispatch(handleUpdateHours(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskAssignments);
